declare global {
  interface Window {
    menloHubLayoutScroll: ($elm: HTMLElement) => void;
  }
}

export function initMenloHubLayout() {
  window.menloHubLayoutScroll = function scrollEvt($elm: HTMLElement) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $parent = $elm.parentElement!;
    if ($elm.scrollTop > 10) {
      $parent.classList.add('s__scrolled');
    } else {
      $parent.classList.remove('s__scrolled');
    }
  };
}
